import { fetchPostCreditCardCrossSellOffer } from '@iwoca/lapi-client/edge';
import { useMutation } from '@tanstack/react-query';

import { useStateKey } from '../../../../../iwQueryClient/useStateKey';

export const useGenerateCreditCardOffer = () => {
    const stateKey = useStateKey();

    return useMutation({
        mutationFn: async () => {
            const { data } = await fetchPostCreditCardCrossSellOffer({
                stateKey,
                body: {}
            });

            return data;
        }
    });
};
